import { createFileRoute } from "@tanstack/react-router";
import { StateLocationsHub, type StateCity } from "@/components/site/StateLocationsHub";
import vb__asset from "@/assets/restore/locations/virginia-beach.jpg.asset.json";

const map = (q: string) =>
  `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(q)}`;

const cities: StateCity[] = [
  {
    name: "Virginia Beach",
    serviceArea: "virginia-beach",
    address: "780 Lynnhaven Pkwy, Suite 400",
    img: vb__asset.url,
    mapUrl: map("780 Lynnhaven Pkwy Virginia Beach VA"),
    to: "/locations/virginia/virginia-beach/",
  },
];

export const Route = createFileRoute("/locations/virginia/")({
  head: () => ({
    meta: [
      { title: "Virginia Hair Transplants | RESTORE® Hair" },
      {
        name: "description",
        content:
          "RESTORE® Hair in Virginia. Book a free personal hair loss consultation at our Virginia Beach location and learn about our FUE hair transplant procedure.",
      },
      { property: "og:title", content: "Virginia Hair Transplants | RESTORE® Hair" },
      {
        property: "og:description",
        content:
          "See RESTORE® Hair in Virginia Beach, Virginia and book a free consultation.",
      },
      { property: "og:url", content: "https://restorehair.com/locations/virginia/" },
    ],
    links: [{ rel: "canonical", href: "https://restorehair.com/locations/virginia/" }],
  }),
  component: () => <StateLocationsHub stateName="Virginia" cities={cities} />,
});